module.exports = __webpack_public_path__ + "img/hn.393738cd.svg";